const taxes = {
  taxes: 'Taxes',
  addTaxes: 'Add Taxes',
  editTaxes: 'Edit Taxes',
};
export default taxes;
